import { Directive } from '@angular/core';

@Directive({
  selector: '[rxAutocompleteOption]',
})
export class RxAutocompleteOptionDirective {
  constructor() {}
}
